<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>{{ type === 'add' ? 'Přidat promo bar' : 'Detail promo baru' }}</h1>

      <v-layout column style="max-width: 800px; gap: 20px;">

        <v-text-field
          v-if="type !== 'add'"
          label="ID"
          disabled
          outlined
          v-model="data.id"
          style="max-width: 120px;"
        />

        <v-text-field
          label="Text akce *"
          outlined
          v-model="data.text"
          :error-messages="makeError(errors.text)"
          @input="errors.text = ''"
          hint="Zobrazovaný text v promo baru"
          persistent-hint
        />

        <v-text-field
          label="URL (volitelná)"
          outlined
          v-model="data.url"
          placeholder="https://"
          :error-messages="makeError(errors.url)"
          @input="errors.url = ''"
          hint="Odkaz po kliknutí na text"
          persistent-hint
        />

        <v-layout style="gap: 24px;">
          <v-text-field
            label="Platnost od *"
            outlined
            type="datetime-local"
            v-model="data.valid_from"
            :error-messages="makeError(errors.valid_from)"
            @input="errors.valid_from = ''"
          />
          <v-text-field
            label="Platnost do *"
            outlined
            type="datetime-local"
            v-model="data.valid_to"
            :error-messages="makeError(errors.valid_to)"
            @input="errors.valid_to = ''"
          />
        </v-layout>

        <v-switch
          v-model="data.is_active"
          label="Aktivní"
        />

      </v-layout>

      <v-layout class="layout--controls mt-4">
        <v-btn color="primary" @click="save()" :loading="saving">
          {{ type === 'add' ? 'Vytvořit' : 'Uložit' }}
        </v-btn>
        <v-btn
          v-if="type !== 'add'"
          color="error"
          class="ml-2"
          @click="confirmDelete = true"
        >Smazat</v-btn>
        <v-btn text class="ml-2" @click="$router.push({name: 'PromoBar'})">Zpět</v-btn>
      </v-layout>

      <v-dialog v-model="confirmDelete" max-width="400">
        <v-card>
          <v-card-title>Smazat promo bar?</v-card-title>
          <v-card-text>Tato akce je nevratná.</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="confirmDelete = false">Zrušit</v-btn>
            <v-btn color="error" @click="deleteItem()">Smazat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'PromoBarDetail',
  data() {
    return {
      loaded: false,
      saving: false,
      confirmDelete: false,
      type: 'edit',
      data: {
        id: null,
        text: '',
        url: '',
        valid_from: '',
        valid_to: '',
        is_active: true,
      },
      errors: {
        text: '',
        url: '',
        valid_from: '',
        valid_to: '',
      },
    };
  },
  created() {
    this.type = this.$route.params.id === 'add' ? 'add' : 'edit';
    if (this.type === 'edit') {
      this.fetchData();
    } else {
      this.loaded = true;
    }
  },
  computed: {
    ...mapState(['profile']),
  },
  methods: {
    makeError(error) {
      return error ? [error] : [];
    },
    formatForInput(dateStr) {
      return dateStr ? moment(dateStr).format('YYYY-MM-DDTHH:mm') : '';
    },
    fetchData() {
      this.$axios.get(`/admin/promo-bars/${this.$route.params.id}`).then((response) => {
        const pb = response.data.promo_bar;
        this.data = {
          ...pb,
          valid_from: this.formatForInput(pb.valid_from),
          valid_to: this.formatForInput(pb.valid_to),
          is_active: !!pb.is_active,
        };
        this.loaded = true;
      }).catch(() => {
        this.loaded = true;
      });
    },
    save() {
      this.saving = true;
      const payload = {
        text: this.data.text,
        url: this.data.url || null,
        valid_from: this.data.valid_from,
        valid_to: this.data.valid_to,
        is_active: this.data.is_active,
      };

      const request = this.type === 'add'
        ? this.$axios.post('/admin/promo-bars/add', payload)
        : this.$axios.put(`/admin/promo-bars/${this.data.id}/edit`, payload);

      request.then(() => {
        this.$router.push({ name: 'PromoBar' });
      }).catch((e) => {
        const data = e?.response?.data;
        if (data?.error_inputs) {
          Object.assign(this.errors, data.error_inputs);
        }
        this.saving = false;
      }).finally(() => {
        this.saving = false;
      });
    },
    deleteItem() {
      this.$axios.delete(`/admin/promo-bars/${this.data.id}/delete`).then(() => {
        this.$router.push({ name: 'PromoBar' });
      }).catch(() => {
        // selhání – zůstaň na stránce
      });
      this.confirmDelete = false;
    },
  },
};
</script>

<style lang="scss">
.required {
  color: red;
}
</style>

